import intl from 'react-intl-universal';
import { FormItem, Dropdown } from '@getsynapse/design-system';

const ChangeToForm = () => {
  const options = [
    {
      label: intl.get(
        'SETTINGS_PAGE.USER_PAGE.CHANGE_LD_USER_TO_BUSINESS.MODAL.CHANGE_TO_FORM.BUSINESS_USER'
      ),
      value: 'business',
    },
  ];

  return (
    <FormItem
      label={intl.get(
        'SETTINGS_PAGE.USER_PAGE.CHANGE_LD_USER_TO_BUSINESS.MODAL.CHANGE_TO_FORM.LABEL'
      )}
    >
      <Dropdown
        options={options}
        values={options}
        onChange={() => {}}
        disabled
      />
    </FormItem>
  );
};

export default ChangeToForm;
